import { render, staticRenderFns } from "./funnel-single-select.vue?vue&type=template&id=647f20e3&scoped=true"
import script from "./funnel-single-select.vue?vue&type=script&lang=js"
export * from "./funnel-single-select.vue?vue&type=script&lang=js"
import style0 from "./funnel-single-select.vue?vue&type=style&index=0&id=647f20e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647f20e3",
  null
  
)

export default component.exports